module.exports = __webpack_public_path__ + "6f61d6318c037f7c9a82569f9696b9fe.svg";